(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-se-root]').forEach(root => {
      if (root.dataset.seReady) return;
      root.dataset.seReady = 'true';
      const main = root.querySelector('[data-se-main-image]');
      const thumbs = [...root.querySelectorAll('[data-se-thumb]')];
      thumbs.forEach((button, index) => button.addEventListener('click', () => {
        thumbs.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        main.src = button.dataset.src;
        main.removeAttribute('srcset');
        main.alt = button.dataset.alt;
        root.querySelector('[data-se-image-count]').textContent = `Image ${index + 1} of ${thumbs.length}`;
      }));
      const modes = [...root.querySelectorAll('[data-se-mode]')];
      modes.forEach(button => button.addEventListener('click', () => {
        modes.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        root.querySelectorAll('[data-se-panel]').forEach(panel => { panel.hidden = panel.dataset.sePanel !== button.dataset.seMode; });
        root.querySelectorAll('[data-se-mode-image]').forEach(img => { img.hidden = img.dataset.seModeImage !== button.dataset.seMode; });
      }));
      const buy = root.querySelector('[data-se-buy]');
      const sticky = root.querySelector('[data-se-sticky]');
      if (buy && sticky && 'IntersectionObserver' in window) {
        const updateSticky = () => {
          const show = buy.getBoundingClientRect().bottom < 0;
          sticky.hidden = !show;
          document.body.style.paddingBottom = show ? `${sticky.offsetHeight}px` : '';
        };
        const observer = new IntersectionObserver(updateSticky);
        observer.observe(buy);
        // A jump can skip the form entirely without changing intersection state.
        let pendingFrame = false;
        window.addEventListener('scroll', () => {
          if (pendingFrame) return;
          pendingFrame = true;
          requestAnimationFrame(() => { updateSticky(); pendingFrame = false; });
        }, { passive: true });
        updateSticky();
        sticky.querySelector('button').addEventListener('click', () => {
          buy.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          buy.querySelector('button[type="submit"]').focus({ preventScroll: true });
        });
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
